export default "__VITE_ASSET__JI_hXguQ__"